import React, { useEffect, useState } from 'react';
import { Page } from 'react-pdf';
import { useInView } from 'react-intersection-observer';
import PDFNotification from '../PdfNotification';
import { pageStyle } from './pdfPage.linaria';
/**
 * If we're doing infinite scroll we want to render the previous page,
 * and the number of pages defined by "pagesToRender"
 */
const getShouldRender = (pageNumber, currentFocus, pagesToRender) => {
    return (pageNumber >= currentFocus - 2 &&
        pageNumber < currentFocus - 2 + pagesToRender);
};
function PdfPage({ pageNumber, onRenderSuccess, currentFocus, onPageFocused, pagesToRender, defaultPageHeight, inifiniteScrollActive, width, height, scale, }) {
    const { ref, inView, entry } = useInView({
        threshold: 0.1,
    });
    /**
     * We use this so that the page can have a defined height, even if the
     * page isn't rendered, so the website doesn't start jumping around once the page is
     * actually loaded
     */
    const [pageHeight, setPageHeight] = useState(undefined);
    const onPageRendered = (pdfPage) => {
        setPageHeight(pdfPage.height);
        if (onRenderSuccess) {
            onRenderSuccess(pdfPage);
        }
    };
    useEffect(() => {
        if (inView && onPageFocused) {
            onPageFocused(pageNumber);
        }
    }, [inView, entry === null || entry === void 0 ? void 0 : entry.intersectionRatio]);
    const shouldRender = !inifiniteScrollActive ||
        inView ||
        getShouldRender(pageNumber, currentFocus, pagesToRender);
    const loader = <PDFNotification text={`Laster side ${pageNumber}`}/>;
    const error = <PDFNotification text="Kunne ikke laste side"/>;
    return (<div className={`${pageStyle} hj-pdf-page-container`} style={{ height: pageHeight || defaultPageHeight }} ref={ref}>
      {/* We always render the loader, so in case there's anything causing the page not to render we have a box saying "Loading page" */}
      {shouldRender && (<>
          {loader}
          <Page error={error} loading={loader} height={height} width={width} scale={scale} pageNumber={pageNumber} onRenderSuccess={onPageRendered}/>
        </>)}
    </div>);
}
PdfPage.defaultProps = {
    defaultPageHeight: 100,
    pagesToRender: 4,
    onPageFocused: undefined,
    onRenderSuccess: undefined,
    currentFocus: undefined,
    inifiniteScrollActive: false,
    width: undefined,
    height: undefined,
    scale: undefined,
};
export default PdfPage;
